export default function() {
     function supportsModernJS() {
        try {
            return window.HTMLDialogElement && window.ResizeObserver
        } catch (err) {
            return false;
        }
    };
    

    window.cmhr = window.cmhr || {};
    const res = supportsModernJS();
    if (res) {
        document.documentElement.classList.add('m-js');
        window.isCmhrModernJs = true;
    }
    return res;
}